<template>
  <div>
    <el-form ref="form" label-width="80px">
      <el-form-item v-for="item in parameterShow" :label="item.label" :key="item.name">
        <el-input v-if="item.type==='string'" v-model="item.value" :placeholder="item.placeholder" :disabled="item.disabled" :maxlength="item.maxlength" :show-word-limit="item.showWordLimit" :clearable="item.clearable"></el-input>
        <el-input v-else-if="item.type==='number'" v-model="item.value" :placeholder="item.placeholder" :disabled="item.disabled" :maxlength="item.maxlength" :show-word-limit="item.showWordLimit" :clearable="item.clearable" type="number"></el-input>
     </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ProcessFormCommit",
  props:{
    parameters:{
      type:Array,
      default(){
        return []
      }
    },
    formId:{
      type:Number,
      //非空
      required:true
    }
  },
  data() {
    return {
      parameterAll:[],
      parameterShow:[],
      formName:""
    }
  },
  mounted() {
    this.parameterAll = this.getAllParameters()
  },
  methods: {
    getAllParameters(){
      let _parameters = []
      return _parameters
    },
    getParameterShow(){
      this.parameterAll.forEach(item => {
        let data = this.parameters.find(item2 => item2.name === item.name)
        //不传默认值就显示
        if (data === undefined){
          this.parameterShow.push(item)
        } else {
          if (data.label){
            //如果label有值，重新赋值label
            item.label = data.label
          }
          if (data.value){
            //赋值
            item.value = data.value
          } else if (item.mast === '1'){
            //必填其默认值为空时，显示
            this.parameterShow.push(item)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>